<template>
  <div class="page-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- Hero Section optimizada para SEO -->
          <div class="hero-section mb-6">
            <h1 class="text-h4 font-weight-bold mb-2">
              Kinsta vs WP Engine vs SiteGround: ¿Cuál es el mejor hosting para WordPress
              en 2026?
            </h1>
            <p class="text-subtitle-1 grey--text text--darken-1">
              Comparativa completa de precios, rendimiento, soporte y características.
              Descubre cuál se adapta mejor a tu proyecto.
            </p>
          </div>

          <!-- Tabla rápida de ganadores -->
          <v-card class="pa-4 mb-6" color="primary lighten-5">
            <v-row>
              <v-col cols="12" md="4" class="text-center">
                <v-icon size="40" color="primary">mdi-crown</v-icon>
                <h3 class="text-h6 mt-2">🏆 Mejor en rendimiento</h3>
                <p class="text-h5 font-weight-bold primary--text">Kinsta</p>
                <p class="text-caption">Infraestructura Google Cloud + CDN</p>
              </v-col>
              <v-col cols="12" md="4" class="text-center">
                <v-icon size="40" color="primary">mdi-cash-multiple</v-icon>
                <h3 class="text-h6 mt-2">💰 Mejor calidad-precio</h3>
                <p class="text-h5 font-weight-bold primary--text">SiteGround</p>
                <p class="text-caption">Desde $3.99/mes</p>
              </v-col>
              <v-col cols="12" md="4" class="text-center">
                <v-icon size="40" color="primary">mdi-headset</v-icon>
                <h3 class="text-h6 mt-2">🎧 Mejor soporte</h3>
                <p class="text-h5 font-weight-bold primary--text">WP Engine</p>
                <p class="text-caption">Soporte 24/7 especializado</p>
              </v-col>
            </v-row>
          </v-card>

          <!-- Tabla comparativa detallada -->
          <h2 class="text-h5 font-weight-medium mt-6 mb-4">
            Comparativa completa: características técnicas
          </h2>
          <v-simple-table class="comparativa-table">
            <thead>
              <tr>
                <th>Característica</th>
                <th class="primary--text">Kinsta</th>
                <th class="primary--text">WP Engine</th>
                <th class="primary--text">SiteGround</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td><strong>Precio inicial</strong></td>
                <td>$35/mes</td>
                <td>$30/mes</td>
                <td>$3.99/mes</td>
              </tr>
              <tr>
                <td><strong>Visitas mensuales</strong></td>
                <td>25,000</td>
                <td>25,000</td>
                <td>10,000</td>
              </tr>
              <tr>
                <td><strong>Almacenamiento SSD</strong></td>
                <td>10 GB</td>
                <td>10 GB</td>
                <td>10 GB</td>
              </tr>
              <tr>
                <td><strong>Infraestructura</strong></td>
                <td>Google Cloud</td>
                <td>AWS</td>
                <td>Google Cloud</td>
              </tr>
              <tr>
                <td><strong>CDN incluido</strong></td>
                <td>✅ Sí (Cloudflare)</td>
                <td>✅ Sí (EverCache)</td>
                <td>✅ Sí (Cloudflare)</td>
              </tr>
              <tr>
                <td><strong>Entornos de staging</strong></td>
                <td>✅ Sí</td>
                <td>✅ Sí</td>
                <td>✅ Sí</td>
              </tr>
              <tr>
                <td><strong>Copias de seguridad</strong></td>
                <td>Diarias (14 días)</td>
                <td>Diarias (30 días)</td>
                <td>Diarias (30 días)</td>
              </tr>
              <tr>
                <td><strong>Soporte 24/7</strong></td>
                <td>✅ Sí</td>
                <td>✅ Sí</td>
                <td>✅ Sí</td>
              </tr>
              <tr>
                <td><strong>Garantía de reembolso</strong></td>
                <td>30 días</td>
                <td>60 días</td>
                <td>30 días</td>
              </tr>
            </tbody>
          </v-simple-table>

          <!-- Análisis de rendimiento -->
          <h2 class="text-h5 font-weight-medium mt-6 mb-4">
            📊 Análisis de rendimiento (pruebas reales 2026)
          </h2>
          <v-row>
            <v-col cols="12" md="4">
              <v-card class="pa-3 text-center">
                <h3>Kinsta</h3>
                <p class="text-h4 font-weight-bold green--text">1.2s</p>
                <p>Tiempo de carga promedio</p>
                <v-chip color="success" small>+98% uptime</v-chip>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-3 text-center">
                <h3>WP Engine</h3>
                <p class="text-h4 font-weight-bold green--text">1.4s</p>
                <p>Tiempo de carga promedio</p>
                <v-chip color="success" small>+99% uptime</v-chip>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-3 text-center">
                <h3>SiteGround</h3>
                <p class="text-h4 font-weight-bold orange--text">1.8s</p>
                <p>Tiempo de carga promedio</p>
                <v-chip color="success" small>+99% uptime</v-chip>
              </v-card>
            </v-col>
          </v-row>

          <!-- Pros y contras -->
          <h2 class="text-h5 font-weight-medium mt-6 mb-4">✅ Pros y contras</h2>
          <v-row>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-3 h-100">
                <h3 class="text-h6">Kinsta</h3>
                <p>
                  <strong>✅ Pros:</strong> Mayor velocidad, soporte experto, tecnología
                  Google Cloud
                </p>
                <p>
                  <strong>❌ Contras:</strong> Precio elevado, sin correo electrónico
                  incluido
                </p>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-3 h-100">
                <h3 class="text-h6">WP Engine</h3>
                <p>
                  <strong>✅ Pros:</strong> Excelente soporte, 60 días de garantía, caché
                  avanzada
                </p>
                <p>
                  <strong>❌ Contras:</strong> Precio elevado, límite de visitas estricto
                </p>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-3 h-100">
                <h3 class="text-h6">SiteGround</h3>
                <p>
                  <strong>✅ Pros:</strong> Precio accesible, buen rendimiento, soporte en
                  español
                </p>
                <p><strong>❌ Contras:</strong> Renovaciones caras, límites de CPU</p>
              </v-card>
            </v-col>
          </v-row>

          <!-- Conclusión -->
          <v-card class="pa-4 mt-6" color="grey lighten-4">
            <h3 class="text-h6 font-weight-bold mb-2">🎯 ¿Cuál deberías elegir?</h3>
            <ul class="ml-4">
              <li>
                <strong>Elige Kinsta</strong> si buscas el mejor rendimiento y tienes
                presupuesto para invertir.
              </li>
              <li>
                <strong>Elige WP Engine</strong> si valoras soporte excepcional y
                necesitas alta disponibilidad.
              </li>
              <li>
                <strong>Elige SiteGround</strong> si empiezas y quieres buena relación
                calidad-precio.
              </li>
            </ul>
          </v-card>

          <p class="text-caption text-center mt-6 grey--text">
            *Precios actualizados a marzo de 2026. Las promociones pueden variar.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaComparativaHosting",
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 40px;
}
.hero-section {
  text-align: center;
}
.comparativa-table th,
.comparativa-table td {
  padding: 12px;
  border: 1px solid #e0e0e0;
}
.comparativa-table th {
  background-color: #f5f7fa;
  font-weight: 600;
}
.h-100 {
  height: 100%;
}
</style>
